<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import InitialsAvatar from '@uiKit/components/InitialsAvatar.vue'
import PropertyDetailSection from './PropertyDetailSection.vue'
import type { DeveloperCard } from '../utils/propertyDetailUtils'

// ABOUT (Figma 32590:61799) + the developer card 24px beneath it (32590:61804).
// Developer logo / tagline aren't in the API yet: the card shows the name's
// initial and "-" until they are.

interface Props {
  description: string
  developer: DeveloperCard | null
}

defineProps<Props>()

const EMPTY_VALUE = '-'
</script>

<template>
  <Box v-if="description || developer" direction="col" gap="24px">
    <PropertyDetailSection v-if="description" title="About">
      <Text type="body" color="muted" class="pd-about__text">{{ description }}</Text>
    </PropertyDetailSection>

    <Box v-if="developer" align="center" gap="10px" class="pd-about__developer">
      <InitialsAvatar :name="developer.name" :src="developer.logoUrl" :size="40" radius="8px" />
      <Box direction="col" gap="1" class="pd-about__developer-text">
        <Text
          type="heading"
          weight="semibold"
          color="var(--p-sliceal-gray-900)"
          is="span"
          style="line-height: 24px"
          >{{ developer.name }}</Text
        >
        <Text
          type="body"
          color="var(--p-surface-500)"
          is="span"
          truncate
          style="line-height: 20px"
          >{{ developer.tagline || EMPTY_VALUE }}</Text
        >
      </Box>
    </Box>
  </Box>
</template>

<style scoped>
.pd-about__text {
  line-height: 1.7;
  letter-spacing: -0.14px;
  white-space: pre-line;
}

.pd-about__developer {
  padding: 10px 12px;
  border: 1px solid var(--p-sliceal-gray-100);
  border-radius: 10px;
  background: var(--p-surface-0);
  overflow: hidden;
}

.pd-about__developer-text {
  flex: 1;
  min-width: 0;
}
</style>
